import Head from 'next/head';
import Link from 'next/link';

import { OutwardRemittancesHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{OutwardRemittancesHelpSEO.metaTitle}</title>
        <meta
          name="description"
          content={OutwardRemittancesHelpSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={OutwardRemittancesHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://www.muthootfincorpone.com/help/forex/outward-remittances/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Forex Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Outward Remittances
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Outward Remittances
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How many days would it take for money to reach the beneficiary
                  account?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE all the international money transfers
                    are completed within 24* hours by us. However, the receiving
                    bank can sometimes take more than 24* hours to reflect the
                    transaction into the recipient’s bank account.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  Why is my money not credited to the beneficiary account even
                  in 48 hours?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    When your money is not credited to the beneficiary account
                    even in 48 hours, it could be due to several reasons.
                    Firstly, check if there is an international bank holiday,
                    secondly, the receiving bank might be taking some extra
                    time.
                    <br /> We suggest that you wait for one more day, and still,
                    if your money isn’t credited, please contact our customer
                    support.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  What are the circumstances that might lead to rejection of an
                  outward remittance request?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Your outward remittance can be rejected due to the following
                    reasons:
                    <br />
                    i. If the Liberalized Remittance Scheme (LRS) of USD
                    2,50,000 limit has already been utilized
                    <br />
                    ii. If there is an insufficient balance in your account
                    <br />
                    iii. If the beneficiary country is not in RBI’s; permitted
                    country list’
                    <br />
                    iv. If you have entered incorrect details of the beneficiary
                    account
                    <br />
                    v. If the purpose of your amount transfer not covered under
                    LRS
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What are the documents required for making an international
                  money transfer at Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    For international money transfer, your documents would vary
                    for different purposes. Here is a list of the following:
                    <br />
                    i.
                    <span className="text--bold">
                      To transfer funds to close relatives
                    </span>{' '}
                    (‘relati Senderanies Act, 2013) abroad, you will need to
                    submit:
                    <br /> -<span className="text--bold"> Sender</span>: A2
                    form, (Form A2 is a FEMA declaration cum application for the
                    purchase of foreign exchange for remittance purposes and
                    mandated by RBI), address proof (Aadhar Card/Driving
                    Licence/Passport or Voter ID), relationship proof
                    (Passport/marriage certificate etc)
                    <br /> - <span className="text--bold">Receiver</span>:
                    Passport copy (with a declaration stating the relationship
                    proof)
                    <br />
                    ii.{' '}
                    <span className="text--bold">
                      When you need to transfer for medical visit
                    </span>
                    , you will need to submit -{' '}
                    <span className="text--bold">Sender</span>: A2 form (Form A2
                    is a FEMA declaration cum application for the purchase of
                    foreign exchange for remittance purposes and mandated by
                    RBI), Address proof (Aadhar Card/Driving Licence/
                    passport/Voter ID), relationship proof with close relative
                    lose relatives (‘relative’ as defined in Section 2(77) of
                    the Companies Act, 2013){' '}
                    <span className="text--bold">Receiver</span>: Letter from
                    hospital and their passport copy
                    <br /> iii.{' '}
                    <span className="text--bold">
                      To transfer funds to an educational institute
                    </span>
                    , you will need to submit:
                    <br /> <span className="text--bold">Sender</span>: A2 form
                    (Form A2 is a FEMA declaration cum application for the
                    purchase of foreign exchange for remittance purposes and
                    mandated by RBI), Address proof (Aadhar Card/Driving
                    Licence/Passport/Voter ID), relationship proof with close
                    relative lose relatives (‘relative’ as defined in Section
                    2(77) of the Companies Act, 2013)
                    <span className="text--bold">Receiver</span>: University
                    acceptance and admission Letter along with the passport
                    copy.
                    <br /> iv.{' '}
                    <span className="text--bold">
                      For gift and donations
                    </span>{' '}
                    you will need to submit:-
                    <span className="text--bold">Sender</span>: -A2 form (Form
                    A2 is a FEMA declaration cum application for the purchase of
                    foreign exchange for remittance purposes and mandated by
                    RBI), KYC documents (Aadhar Card/Driving Licence/Pan
                    Card/Passport/Voter ID) and PAN Card.{' '}
                    <span className="text--bold">Receiver</span>: Valid Bank
                    Account Details
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  How much is the GST charged on forex services?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The following GST slabs are applicable for Forex
                    transactions:
                    <br />
                    <br />
                    1. 0.18% of the total amount up to Rs. 100,000, subject to a
                    minimum of Rs. 45
                    <br />
                    2. Rs. 180 plus 0.09% of the total amount for an amount
                    between Rs. 1,00,000 and to Rs. 10,00,000
                    <br />
                    3. Rs. 990 plus 0.018% of the total amount exceeding Rs.
                    10,00,000
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is Tax Collected at Source (TCS) and when is it deducted
                  on my Forex transactions?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    According to the RBI guidelines, Tax Collected at Source
                    (TCS) is the tax you have to pay if your order exceeds INR
                    7,00,000. The tax charged will then be 5% for a taxpayer and
                    10% for a non-taxpayer.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  What all currencies can I purchase from Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot FinCorp ONE offers all major and legally accepted
                    currencies. The list of currencies available are: U.S dollar
                    (USD), Euro (EUR), Japanese Yen (JPY), Pound sterling (GBP),
                    Renminbi (CNY), Australian dollar (AUD), Canadian dollar
                    (CAD), Swiss franc (CHF), Hong Kong dollar (HKD), Singapore
                    dollar (SGD), UAE dirham (AED), Saudi Riyal (SAR), Malaysian
                    ringgit (MYR), Thai baht (THB) and New Zealand dollar (NZD).
                    <br />
                    You can get these anytime within 24* hours. However, the
                    availability of some of these currencies&apos; can be
                    subject to market liquidity.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  What is the ‘Block Rate’ feature on Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The block rate feature on Muthoot FinCorp ONE allows you to
                    lock-in your Forex exchange rate for two days just by paying
                    a nominal premium for your order.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  What is the ‘Buy Back Guarantee’ feature on Muthoot FinCorp
                  ONE?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE we give you the buy-back guarantee
                    feature with a promise to buy your the purchased or
                    left-over currency from you, at the same exchange rate you
                    had purchased from us. You can do this within a period of 15
                    days, from the date of purchase.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTen"
                data-toggle="collapse"
                data-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
              >
                <p className="text--black text--semi title">
                  What is the verification process to buy, sell and reload Forex
                  at Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseTen"
                className="collapse"
                aria-labelledby="headingTen"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE you can complete your KYC or
                    verification process either through an online video-KYC or
                    by visiting a nearby Muthoot FinCorp Forex Branch with your
                    documents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
